import { Enumerated } from './Enumerated';

class USER_STATE extends Enumerated {

  static GUEST = 'guest'
  static HOST = 'host'
}

export { USER_STATE };
